export const unloading = {
    state: {
        photos: [],
        status: 'discharged'
    },
    mutations: {
        SET_UNLOADING_STATUS(state, status) {
            state.status = status
        },
        ADD_UNLOADING_PHOTO(state, photo){
            state.photos.push(photo)
        },
        REMOVE_UNLOADING_PHOTO(state, photosToRemove){
            for(const photoToRemove of photosToRemove) {
                const idx = state.photos.findIndex(photo => photo.id === photoToRemove)
                if(idx > -1) {
                    state.photos.splice(idx, 1)
                }
            }
        },

    },
    actions: {
        addUnloadingPhoto({ commit }, image){
            commit('ADD_UNLOADING_PHOTO', {
                id: Date.now(),
                image
            })
        },
        removeUnloadingPhoto({ commit }, photosToRemove){
            commit('REMOVE_UNLOADING_PHOTO', photosToRemove)
        }
    },
    getters : {
        unloadingPhotos: (state) => {
            return state.photos
        },
        unloadingPhotosForApi: (state) => {
            return state.photos.map(photo => photo.image)
        },
        unloadingStatus: (state) => {
            return state.status
        }
    }
}
